/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import BeneficiaryAccountStepBank from "../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountCreate/BeneficiaryAccountStepBank/index.jsx";
import BeneficiaryAccountStepCategories from "../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountCreate/BeneficiaryAccountStepCategories/index.jsx";
import BeneficiaryAccountStepConfirm from "../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountCreate/BeneficiaryAccountStepConfirm/index.jsx";
import BeneficiaryAccountStepContact from "../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountCreate/BeneficiaryAccountStepContact/index.jsx";
import BeneficiaryAccountStepPAN from "../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountCreate/BeneficiaryAccountStepPAN/index.jsx";
import {
  createBeneficiaryAccount,
  resetCreateBeneficiaryAccount,
} from "../../../../redux/features/accounts/beneficiaryAccount/index.js";
import {
  bankLookUp,
  getIFSCDetails,
  panLookUp,
  resetBankLookupData,
  resetBankLookupError,
  resetBankVerification,
  resetGSTVerification,
  resetPanLookup,
  resetPANVerification,
  verifyBankAccount,
  verifyGST,
  verifyPAN,
} from "../../../../redux/features/sharedResources/sharedResources";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText.js";
import Validation from "../../../../utils/validation";

const BeneficiaryAccountCreate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const scrollIt = useRef(null);
  const lastVerifiedPanRef = useRef(null);
  const [labels, setLabels] = useState([]);
  const [initialRecipientCount] = useState(0);
  const [exitFlow, setExitFlow] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [GSTStatus, setGSTStatus] = useState(null);
  const [direction, setDirection] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [GSTLinked, setGSTLinked] = useState(false);
  const [lookupNext, setLookupNext] = useState(false);
  const [labelpopup, setLabelpopup] = useState(false);
  const [customErrors, setCustomErrors] = useState({});
  const [gstVerified, setGstVerified] = useState(null);
  const [verifiedPan, setVerifiedPan] = useState(null);
  const [selectedFields, setSelectedFields] = useState([]);
  const [tempRecipients, setTempRecipients] = useState([]);
  const [createRecipient, setCreateRecipient] = useState([]);
  const [bankLookupNext, setBankLookupNext] = useState(false);
  const [virtualAccount, setVirtualAccount] = useState(false);
  const [removeClassName, setRemoveClassName] = useState(true);
  const [selectedCatFields, setSelectedCatFields] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [selectedValue, setSelectedValue] = useState("legalname");
  const [originalRecipients, setOriginalRecipients] = useState([]);
  const [disableCreateNext, setDisableCreateNext] = useState(false);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const [openAssociatePopup, setOpenAssociatePopup] = useState(false);
  const [selectedLabelsCreate, setSelectedLabelsCreate] = useState([]);
  const [isNextButtonEnabled, setIsNextButtonEnabled] = useState(false);
  const [isBankLinkedAccount, setIsBankLinkedAccount] = useState(false);
  const [showAlertCategories, setShowAlertCategories] = useState(false);
  const [manualVirtualAccount, setManualVirtualAccount] = useState(false);
  const [accountNameValidation, setAccountNameValidation] = useState(true);
  const [showAdditionalSection, setShowAdditionalSection] = useState(false);
  const [showAdditionalRecipient, setShowAdditionalRecipient] = useState([]);
  const [bankVerificationStatus, setBankVerificationStatus] = useState(false);
  const [recipientButtonDisabled, setRecipientButtonDisabled] = useState(true);
  const [additionalChip, setAdditionalChip] = useState(showAdditionalRecipient);
  const [accountActiveInactiveState, setAccountActiveInactiveState] =
    useState("active");
  const [currentAssociate, setCurrentAssociate] = useState(
    "Beneficiary account",
  );
  const [newData, setNewData] = useState({
    gstin: "",
  });
  const [payload, setPayload] = useState({
    bank_account: "",
    ifsc_code: "",
    contact_no: "",
    email_id: "",
    gstin: "",
    name: "",
    categories: "",
    panNumber: "",
    gst_org_name: "",
    account_name: "",
    labels: [],
    recipient_email: "",
    virtual: "",
  });

  const steps = [
    "PAN details",
    "Bank details",
    "Contact details",
    "Category, labels and recipients",
    "Confirm and create",
  ];

  const commonStepperConfig = {
    previousEnableBgColor: "var(--primary-nav-act)",
    previousDisableBgColor: "var(--primary-nav-act)",
    previousEnableTextColor: "var(--text-primary)",
    previousHoverOption: "white",
    nextEnableBgColor: "var(--text-primary)",
    nextDisableBgColor: "var(--text-disabled)",
    nextEnableTextColor: "var(--primary-bg)",
    nextDisableTextColor: "var(--text-primary)",
    nextHoverOption: "black",
  };

  const dataArray = steps.map((stepLabel, index) => {
    const isFirstStep = index === 0;
    const isLastStep = index === steps.length - 1;
    const accountLoading = isLastStep && isButtonDisabled;

    return {
      ...commonStepperConfig,
      previousText: isFirstStep ? "Cancel" : "Previous",
      nextText: isLastStep ? "Create" : "Next",
      nextLoaderNeeded: isLastStep,
      nextIsLoading: accountLoading,
      nextIsEnabled: isLastStep
        ? isNextButtonEnabled && !isButtonDisabled
        : index === GlobalConfiguration.lengthCheckOne && manualVirtualAccount
          ? true
          : isNextButtonEnabled && !isButtonDisabled,
      nextEnableBgColor: isLastStep
        ? "var(--positive-act)"
        : "var(--text-primary)",
      nextDisableBgColor: isLastStep
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextEnableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--primary-bg)",
      nextDisableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--text-primary)",
      stepperText: stepLabel,
    };
  });

  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const isIFSCValid =
    payload?.ifsc_code?.length === 11 && ifscRegex.test(payload?.ifsc_code);
  const emailRegex = Validation.emailRegex;

  const animationClass =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const { services, isLoading } = useSelector((state) => state.refreshToken);

  const categories = useSelector(
    (state) => state.sharedResources?.categoriesData?.categories,
  ).filter((cat) => cat?.active === "Y");

  const { panVerificationLoading, panVerificationData, panVerificationError } =
    useSelector((state) => state.sharedResources);
  const { gstVerificationData, gstVerificationLoading } = useSelector(
    (state) => state.sharedResources,
  );
  const { panLookupData, panLookupLoading, panLookupError } = useSelector(
    (state) => state.sharedResources,
  );

  const { bankLookupData, bankLookupError, bankLookupLoading } = useSelector(
    (state) => state.sharedResources,
  );

  const {
    verifyBankAccountData,
    verifyBankAccountLoading,
    verifyBankAccountError,
    verifiyBankAccountMessage,
  } = useSelector((state) => state.sharedResources);

  const { ifscDetailsData, ifscDetailsError, ifscDetailsLoading } = useSelector(
    (state) => state.sharedResources,
  );

  const { beneficiaryAccountDetailsData, beneficiaryAccountDetailsLoading } =
    useSelector((state) => state.beneficiaryAccount);

  const formatValue = (name, value) => {
    if (name === "gstin") {
      return value.toUpperCase();
    }

    if (name === "account_name") {
      return value.replace(/^\s+/, "").replace(/\s{2,}/g, " ");
    }

    return value;
  };

  const allowedValidators = {
    contact_no: Validation.allowedContactNum,
    email_id: Validation.allowedEmail,
  };

  const isAllowedValue = (name, value) => {
    return allowedValidators[name] ? allowedValidators[name](value) : true;
  };

  const fieldValidators = {
    email_id: Validation.validateEmail,
    contact_no: Validation.validateContactNum,
  };

  const validateAndRecordError = (name, value) => {
    const validator = fieldValidators[name];

    if (!validator) return;

    setCustomErrors((prev) => validator(name, value, { ...prev }));
  };

  const updateAccountName = (value, updatedPayload) => {
    const trimmedValue = value.trim();

    if (!trimmedValue) {
      setAccountNameValidation(false);
      return;
    }

    if (trimmedValue === panVerificationData?.pan_details?.full_name) {
      setSelectedValue("legalname");
    } else if (trimmedValue === updatedPayload.userName) {
      setSelectedValue("username");
    } else {
      setSelectedValue("customname");
    }

    setAccountNameValidation(true);
  };

  const handleCreateAccount = async () => {
    if (isButtonDisabled) return;
    try {
      setIsButtonDisabled(true);
      let updatedPayload = { ...payload, navigate };

      const allActiveCategoryIds = categories.map((c) => c.id);

      const selectedCategoryIds = categories
        .filter((c) => selectedFields.includes(c.id))
        .map((c) => c.id);

      updatedPayload = {
        ...updatedPayload,
        category_ids:
          selectedCategoryIds.length > GlobalConfiguration?.lengthCheckZero
            ? selectedCategoryIds
            : allActiveCategoryIds,
      };

      const data = await dispatch(
        createBeneficiaryAccount(updatedPayload),
      ).unwrap();
      const accountId = data?.beneficiary_accounts?.[0]?.id;

      dispatch(resetCreateBeneficiaryAccount());
      navigate(
        `/beneficiary_account_dashboard/create_beneficiary_account/success/${accountId}`,
      );
    } catch (error) {
      console.error(error);
      navigate(
        "/beneficiary_account_dashboard/create_beneficiary_account/failed",
        {
          state: {
            error: {
              message: error?.message,
            },
          },
        },
      );
    } finally {
      setIsButtonDisabled(false);
    }
  };

  const isPanValid = verifiedPan === true;

  const isGstValid =
    payload?.gstin?.length === 0 ||
    (payload?.gstin?.length === 15 && GSTStatus === true);

  const isConfirmDisabled = !isPanValid || !isGstValid;

  const handlePANConfirm = () => {
    if (isConfirmDisabled) return;

    if (
      payload.gstin?.length === GlobalConfiguration?.gstLength &&
      !(GSTStatus && GSTLinked)
    ) {
      return;
    }
    setLookupNext(true);
  };
  const shouldDisableBankConfirm = isBankLinkedAccount && isIFSCValid;

  const isIconGrey = shouldDisableBankConfirm || !bankLookupNext;

  const showJointAccountAlert =
    !isBankLinkedAccount &&
    isIFSCValid &&
    payload?.bank_account?.length > 0 &&
    bankLookupData?.beneficiary_accounts?.some(
      (item) =>
        item?.pan_no !== payload?.panNumber &&
        item?.bank_acc_no === payload?.bank_account,
    );

  const handleMainCreate = () => {
    handleCreateAccount();
  };

  const handleEnterKeyPress = (e) => {
    if (e.key === "Enter" && activeStep === 3) {
      handleMainCreate();
    }
  };

  const handleKeyDown = (event) => {
    if (event.target.tagName === "INPUT") {
    } else if (
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      event.key === "Tab" ||
      event.key === " "
    ) {
      event.preventDefault();
    }
  };

  const handlePANChange = (e) => {
    let inputPan = e.target.value.toUpperCase();
    inputPan = inputPan.replace(/[^A-Z0-9]/g, "");

    if (inputPan.length > GlobalConfiguration?.panLength) {
      return;
    }

    if (inputPan === payload.panNumber) {
      return;
    }

    setVerifiedPan(null);
    lastVerifiedPanRef.current = null;

    dispatch(resetPANVerification());
    dispatch(resetPanLookup());
    dispatch(resetGSTVerification());

    setGSTStatus(null);

    setPayload((prev) => ({
      ...prev,
      panNumber: inputPan,
      gstin: "",
      gst_org_name: "",
      legalName: "",
      account_name: "",
    }));
    setDisableCreateNext(false);
    setLookupNext(false);

    if (
      !panRegex.test(inputPan) &&
      inputPan.length === GlobalConfiguration.panLength
    ) {
      setVerifiedPan(false);
    } else if (inputPan.length === 10) {
      dispatch(
        verifyPAN({
          pan_number: inputPan,
          showToast: false,
        }),
      );
    }
  };

  const handleGSTChange = ({ target: { name, value } }) => {
    if (/[^a-zA-Z0-9]/.test(value)) return;

    if (name === "gstin" && value.length > GlobalConfiguration.gstLength) {
      return;
    }

    const formattedValue = formatValue(name, value.toUpperCase());

    if (formattedValue === payload[name]) return;

    if (!isAllowedValue(name, formattedValue)) return;

    validateAndRecordError(name, formattedValue);

    setPayload((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));

    if (name !== "gstin") return;

    setGstVerified(null);
    setGSTStatus(null);

    setNewData((prev) => ({
      ...prev,
      gstin: formattedValue,
    }));

    if (!formattedValue) return;

    if (formattedValue.length < GlobalConfiguration.gstLength) {
      setGstVerified(false);
      setGSTStatus(false);
      setGSTLinked(false);
    }

    setLookupNext(false);
    dispatch(resetGSTVerification());
  };

  const handleAccountNameSelection = (value) => {
    setSelectedValue(value);

    const accountName =
      value === "legalname"
        ? panVerificationData?.pan_details?.full_name
        : value === "username"
          ? payload.userName
          : "";

    if (!accountName) return;

    setAccountNameValidation(true);

    setPayload((prev) => ({
      ...prev,
      account_name: accountName,
    }));
  };

  const handleRadioBtn = ({ target: { value } }) => {
    handleAccountNameSelection(value);
  };

  const handleDivBtn = (value) => {
    handleAccountNameSelection(value);
  };

  const handleChange = ({ target: { name, value } }) => {
    const formattedValue = formatValue(name, value);

    if (!isAllowedValue(name, formattedValue)) return;

    validateAndRecordError(name, formattedValue);

    setPayload((prev) => {
      const updatedPayload = {
        ...prev,
        [name]: formattedValue,
      };

      if (name === "account_name") {
        updateAccountName(formattedValue, updatedPayload);
      }

      return updatedPayload;
    });
  };

  const handleSelectFieldsChange = (selectedFields) => {
    setSelectedFields(selectedFields);
  };

  const toggleSelection = (category) => {
    const { id } = category;

    setSelectedCatFields((prev) => {
      if (id === "Select All") {
        return prev.length === categories.length
          ? []
          : categories.map(({ id }) => id);
      }

      return prev.includes(id)
        ? prev.filter((item) => item !== id)
        : [...prev, id];
    });
  };

  const handleCategorySelect = (selectedCategories) => {
    const selectedCategoryNames =
      selectedCategories.length > 0
        ? categories
            .filter(({ id }) => selectedCategories.includes(id))
            .map(({ id }) => id)
        : categories.map(({ id }) => id);

    handleSelectFieldsChange(selectedCategoryNames);
  };

  const handleClose = (finalLabels) => {
    setLabelpopup(false);

    if (finalLabels === undefined || finalLabels === null) return;

    setPayload((prevPayload) => ({
      ...prevPayload,
      labels: finalLabels,
    }));

    setSelectedLabelsCreate(finalLabels);
  };

  const openAdditionalRecipients = () => {
    const confirmed = createRecipient || [];
    setTempRecipients(confirmed);
    setOriginalRecipients(confirmed);
    setShowAdditionalSection(true);
  };

  const handleConfirmRecipients = () => {
    if (recipientButtonDisabled) return;

    setCreateRecipient(tempRecipients);
    setShowAdditionalSection(false);
  };

  const handleNext = () => {
    if (
      activeStep === 3 &&
      selectedFields?.length === categories?.length &&
      !showAlertCategories
    ) {
      setShowAlertCategories(true);
      setSelectedLabelsCreate(selectedLabelsCreate || []);
    } else if (activeStep === 4) {
      handleMainCreate();
    } else {
      setShowAlertCategories(false);
      setActiveStep((prevActiveStep) => prevActiveStep + 1);

      setDirection("next");
      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, 1000);
    }
  };

  const handleBack = () => {
    if (activeStep === 0) {
      if (payload?.panNumber?.length === GlobalConfiguration?.lengthCheckZero) {
        navigate(GlobalConfiguration?.navigate_back);
        return;
      } else {
        setExitFlow(true);
        return;
      }
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    setDirection("previous");
    setRemoveClassName(false);
    setTimeout(() => {
      setRemoveClassName(true);
    }, 1000);
  };

  const isPanVerified = verifiedPan === true;
  const ifscData = ifscDetailsData?.ifsc_details?.[0];

  const hasAssociatedAccounts = panLookupData?.status === true;

  const noAssociatedAccounts = panLookupError === true;

  const isGstEmpty =
    payload?.gstin?.length === GlobalConfiguration.lengthCheckZero;

  const isGstVerified =
    payload?.gstin?.length === GlobalConfiguration.gstLength &&
    GSTStatus === true;

  const isGstInvalid =
    payload?.gstin?.length > GlobalConfiguration.lengthCheckZero &&
    !isGstVerified;

  const isGSTPanMatched =
    payload.gstin.substring(2, payload.gstin.length - 3) === payload.panNumber;

  const shouldEnableNextButtonFirstStepper =
    isPanVerified &&
    ((noAssociatedAccounts && (isGstEmpty || isGstVerified)) ||
      (hasAssociatedAccounts && lookupNext)) &&
    !isGstInvalid &&
    !(GSTStatus && disableCreateNext && isGSTPanMatched);

  const bankVerifyGenerationRef = useRef(0);

  const [bankGateSnapshot, setBankGateSnapshot] = useState({
    isBankStatusValid: false,
    bankLookupData: null,
    settled: false,
  });
  const isBankAccountValid = payload?.bank_account?.length > 0;

  const isIfscCodeValid = payload?.ifsc_code?.length === 11;

  const hasNoAssociatedBankAccounts =
    bankGateSnapshot.bankLookupData === null ||
    bankGateSnapshot.bankLookupData?.beneficiary_accounts?.length === 0;

  const canShowManualVirtualToggle =
    bankGateSnapshot.settled &&
    !bankGateSnapshot.isBankStatusValid &&
    isIFSCValid &&
    !ifscDetailsError &&
    verifiyBankAccountMessage === "Invalid Bank Account Number / IFSC" &&
    !ifscDetailsLoading;

  const shouldEnableNextButtonSecondStepper =
    bankGateSnapshot.settled &&
    bankGateSnapshot.isBankStatusValid &&
    isBankAccountValid &&
    isIfscCodeValid &&
    (hasNoAssociatedBankAccounts || bankLookupNext);

  const contactNumberValidation =
    !customErrors.contact_no && payload.contact_no?.length === 10;

  const emailValidation =
    !customErrors.email_id &&
    payload.email_id?.length > 0 &&
    emailRegex.test(payload.email_id);

  const isContactValid =
    payload.contact_no?.length === 10 && contactNumberValidation;

  const isEmailValid = payload.email_id?.length > 0 && emailValidation;

  const isAccountNameValid =
    payload.account_name?.trim().length >= 3 && accountNameValidation;

  const shouldEnableNextButtonThirdStepper =
    isContactValid && isEmailValid && isAccountNameValid;

  useEffect(() => {
    let shouldEnable = false;

    switch (activeStep) {
      case GlobalConfiguration.lengthCheckZero:
        shouldEnable = !panLookupLoading && shouldEnableNextButtonFirstStepper;
        break;

      case GlobalConfiguration.lengthCheckOne:
        shouldEnable = shouldEnableNextButtonSecondStepper;
        break;

      case GlobalConfiguration.lengthCheckTwo:
        shouldEnable = shouldEnableNextButtonThirdStepper;
        break;

      case GlobalConfiguration.lengthCheckThree:
      case GlobalConfiguration.lengthCheckFour:
        shouldEnable = true;
        break;

      default:
        shouldEnable = false;
    }

    setIsNextButtonEnabled(shouldEnable);
  }, [
    activeStep,
    shouldEnableNextButtonFirstStepper,
    shouldEnableNextButtonSecondStepper,
    shouldEnableNextButtonThirdStepper,
    verifyBankAccountData?.status,
    payload?.contact_no,
    payload?.email_id,
    payload.account_name,
    payload?.bank_account,
    payload?.ifsc_code,
    payload?.gstin,
    verifiedPan,
    verifyBankAccountData?.status,
    bankLookupNext,
    bankLookupLoading,
    panLookupData,
    lookupNext,
    panLookupLoading,
    emailValidation,
    contactNumberValidation,
    accountNameValidation,
    selectedFields,
    categories,
    showAlertCategories,
    manualVirtualAccount,
  ]);

  useEffect(() => {
    if (!isLoading && services !== null) {
      if (services?.includes("BUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "BUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleEnterKeyPress);
    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, []);

  useEffect(() => {
    if (labelpopup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [labelpopup]);

  useEffect(() => {
    const foundAccount = bankLookupData?.beneficiary_accounts?.find((val) => {
      if (
        payload?.panNumber === val?.pan_no &&
        payload?.bank_account === val?.bank_acc_no &&
        payload?.ifsc_code === val?.ifsc_code
      ) {
        setIsBankLinkedAccount(true);
        return true;
      }
      return false;
    });

    if (foundAccount) {
      setCurrentAssociate(
        foundAccount?.type_of_account === "field_force"
          ? "Field force account"
          : foundAccount?.type_of_account === "reimbursement"
            ? "Reimbursement account"
            : foundAccount?.type_of_account === "tds"
              ? "Tax account"
              : "Beneficiary account",
      );
      setAccountActiveInactiveState(
        foundAccount?.approval_status === "rejected" ||
          foundAccount?.approval_status === "blocked" ||
          foundAccount?.approval_status === "archived"
          ? "inactive"
          : "active",
      );
    }

    if (!foundAccount) {
      setIsBankLinkedAccount(false);
    }
  }, [bankLookupData, payload]);

  useEffect(() => {
    setSelectedValue("legalname");

    if (!payload.panNumber) {
      setVerifiedPan(null);
      lastVerifiedPanRef.current = null;
      return;
    }

    if (lastVerifiedPanRef.current === payload.panNumber) return;

    if (panVerificationData?.status) {
      lastVerifiedPanRef.current = payload.panNumber;

      setVerifiedPan(true);

      dispatch(
        panLookUp({
          pan_number: payload.panNumber,
        }),
      );

      setPayload((prev) => ({
        ...prev,
        legalName: panVerificationData?.pan_details.full_name,
        account_name: panVerificationData?.pan_details.full_name,
      }));

      return;
    }

    if (
      panVerificationError === true &&
      payload.panNumber.length === GlobalConfiguration.panLength
    ) {
      lastVerifiedPanRef.current = payload.panNumber;
      setVerifiedPan(false);
    }
  }, [payload.panNumber, panVerificationData, panVerificationError]);

  useEffect(() => {
    if (newData.gstin?.length !== GlobalConfiguration.gstLength) {
      setLookupNext(false);
    }
  }, [newData.gstin]);

  useEffect(() => {
    if (gstVerificationLoading) return;

    const gstLength = payload.gstin?.length;

    if (gstLength === GlobalConfiguration.gstLength) {
      const gstPan = payload.gstin.substring(2, payload.gstin.length - 3);

      const isVerified = gstVerificationData?.status === true;
      const isLinked = gstPan === payload.panNumber;

      if (isVerified && isLinked) {
        setGstVerified(true);
        setGSTLinked(true);
        setGSTStatus(true);
      } else {
        setGstVerified(false);
        setGSTLinked(isLinked);
        setGSTStatus(false);
      }
    } else if (
      gstLength === GlobalConfiguration.lengthCheckZero &&
      verifiedPan &&
      !panVerificationLoading
    ) {
      setGSTStatus(null);
      setGstVerified(null);
      setGSTLinked(false);
    } else {
      setGSTStatus(false);
      setGstVerified(false);
      setGSTLinked(false);
    }
  }, [
    gstVerificationData?.status,
    payload.gstin,
    payload.panNumber,
    verifiedPan,
    panVerificationLoading,
    gstVerificationLoading,
  ]);

  useEffect(() => {
    const businessName = gstVerificationData?.gstin_details?.business_name;

    if (!businessName) return;

    setPayload((prev) => ({
      ...prev,
      gst_org_name: businessName,
    }));
  }, [gstVerificationData]);

  useEffect(() => {
    if (
      payload.gstin?.length !== GlobalConfiguration.gstLength ||
      customErrors.gstin
    ) {
      return;
    }

    dispatch(
      verifyGST({
        search_string: payload.gstin,
      }),
    );
  }, [payload.gstin, customErrors.gstin, dispatch]);

  useEffect(() => {
    if (
      beneficiaryAccountDetailsLoading ||
      beneficiaryAccountDetailsData?.status !== true
    ) {
      return;
    }

    const beneficiary =
      beneficiaryAccountDetailsData?.beneficiary_accounts?.[0];

    if (!beneficiary) return;

    setPayload((prev) => ({
      ...prev,
      gstin: beneficiary.gstin_detail || "",
    }));

    if (beneficiary.gstin) {
      dispatch(
        verifyGST({
          gstin: beneficiary.gstin,
        }),
      );
    }
  }, [
    dispatch,
    beneficiaryAccountDetailsLoading,
    beneficiaryAccountDetailsData,
  ]);

  useEffect(() => {
    setPayload((prev) => ({
      ...prev,
      panNumber: "",
      gstin: "",
      gst_org_name: "",
      legalName: "",
      account_name: "",
    }));
    setVerifiedPan(null);
    lastVerifiedPanRef.current = null;
    setGSTStatus(null);
    setGstVerified(null);
    setGSTLinked(false);
    dispatch(resetPANVerification());
    dispatch(resetPanLookup());
    dispatch(resetGSTVerification());
    setManualVirtualAccount(false);
    dispatch(resetBankLookupError());
    dispatch(resetBankVerification());
    dispatch(resetBankLookupData());
  }, [dispatch]);

  useEffect(() => {
    const isValidBankDetails =
      payload.bank_account?.length >= 9 &&
      payload.ifsc_code?.length === 11 &&
      /^[A-Z]{4}0[A-Z0-9]{6}$/.test(payload.ifsc_code);

    const requestId = ++bankVerifyGenerationRef.current;

    setBankGateSnapshot({
      isBankStatusValid: false,
      bankLookupData: null,
      settled: false,
    });
    setBankLookupNext(false);

    if (!isValidBankDetails) return;

    dispatch(
      getIFSCDetails({
        search_string: payload.ifsc_code,
        page_no: GlobalConfiguration.lengthCheckOne,
        page_size: GlobalConfiguration.filterResults,
      }),
    );

    dispatch(
      verifyBankAccount({
        ifsc_code: payload.ifsc_code,
        bank_account: payload.bank_account,
        legal_name: payload.legalName,
        navigate,
      }),
    )
      .unwrap()
      .then(async (verifyResult) => {
        if (requestId !== bankVerifyGenerationRef.current) return;

        if (verifyResult?.status !== true) {
          setBankGateSnapshot({
            isBankStatusValid: false,
            bankLookupData: null,
            settled: true,
          });
          return;
        }

        try {
          const lookupResult = await dispatch(
            bankLookUp({
              ifsc: payload.ifsc_code,
              bank_account_no: payload.bank_account,
            }),
          ).unwrap();

          if (requestId !== bankVerifyGenerationRef.current) return;

          const hasExisting = lookupResult?.beneficiary_accounts?.length > 0;

          setBankGateSnapshot({
            isBankStatusValid: true,
            bankLookupData: lookupResult,
            settled: true,
          });

          if (!hasExisting) {
            setBankLookupNext(true);
          }
        } catch {
          if (requestId !== bankVerifyGenerationRef.current) return;
          setBankGateSnapshot({
            isBankStatusValid: true,
            bankLookupData: null,
            settled: true,
          });
          setBankLookupNext(true);
        }
      })
      .catch(() => {
        if (requestId !== bankVerifyGenerationRef.current) return;
        setBankGateSnapshot({
          isBankStatusValid: false,
          bankLookupData: null,
          settled: true,
        });
      });
  }, [payload.bank_account, payload.ifsc_code, payload.legalName]);

  useEffect(() => {
    if (panLookupLoading || !isIFSCValid || bankLookupError) {
      return;
    }
    if (
      bankLookupData?.beneficiary_accounts?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      setBankLookupNext(false);
      return;
    }

    if (!verifyBankAccountLoading && verifyBankAccountData?.status) {
      setBankLookupNext(true);
    }
  }, [
    panLookupLoading,
    bankLookupData,
    isIFSCValid,
    bankLookupError,
    verifyBankAccountData,
    verifyBankAccountLoading,
  ]);

  useEffect(() => {
    handleCategorySelect(selectedCatFields);
  }, [selectedCatFields]);

  useEffect(() => {
    try {
      const availableLabels = sessionStorage.getItem(
        "beneficiaryAccountLabels",
      );

      if (!availableLabels) {
        setLabels([]);
        return;
      }

      setLabels(JSON.parse(availableLabels));
    } catch (error) {
      console.error("Failed to parse beneficiary Account:", error);
      setLabels([]);
    }
  }, []);

  useEffect(() => {
    const changed =
      JSON.stringify(tempRecipients) !== JSON.stringify(originalRecipients);

    setRecipientButtonDisabled(!changed);
  }, [tempRecipients, originalRecipients]);

  useEffect(() => {
    if (createRecipient?.length > 0) {
      setPayload((prev) => ({
        ...prev,
        recipient_email: createRecipient.join(","),
      }));
    } else {
      setPayload((prev) => {
        const updated = { ...prev };
        delete updated.recipient_email;
        return updated;
      });
    }
  }, [createRecipient]);

  const renderCreateAccount = () => {
    switch (activeStep) {
      case 0:
        return (
          <BeneficiaryAccountStepPAN
            verifiedPan={verifiedPan}
            panNumber={payload.panNumber}
            handlePANChange={handlePANChange}
            panDetails={panVerificationData?.pan_details}
            panLookupData={panLookupData}
            panLookupLoading={panLookupLoading}
            lookupNext={lookupNext}
            panVerificationLoading={panVerificationLoading}
            panLookupError={panLookupError}
            payload={payload}
            GSTStatus={GSTStatus}
            accountActiveInactiveState={accountActiveInactiveState}
            setAccountActiveInactiveState={setAccountActiveInactiveState}
            currentAssociate={currentAssociate}
            setCurrentAssociate={setCurrentAssociate}
            openAssociatePopup={openAssociatePopup}
            setOpenAssociatePopup={setOpenAssociatePopup}
            navigate={navigate}
            showPopup={showPopup}
            setShowPopup={setShowPopup}
            gstVerificationData={gstVerificationData}
            gstVerified={gstVerified}
            gstVerificationLoading={gstVerificationLoading}
            GSTLinked={GSTLinked}
            handleGSTChange={handleGSTChange}
            isConfirmDisabled={isConfirmDisabled}
            handlePANConfirm={handlePANConfirm}
          />
        );
      case 1:
        return (
          <BeneficiaryAccountStepBank
            bankLookupNext={bankLookupNext}
            setBankLookupNext={setBankLookupNext}
            setIsNextButtonEnabled={setIsNextButtonEnabled}
            activeStep={activeStep}
            payload={payload}
            setPayload={setPayload}
            bankVerificationStatus={bankVerificationStatus}
            setBankVerificationStatus={setBankVerificationStatus}
            isIFSCValid={isIFSCValid}
            bankLookupError={bankLookupError}
            virtualAccount={virtualAccount}
            setVirtualAccount={setVirtualAccount}
            isBankLinkedAccount={isBankLinkedAccount}
            setManualVirtualAccount={setManualVirtualAccount}
            manualVirtualAccount={manualVirtualAccount}
            ifscDetailsError={ifscDetailsError}
            ifscData={ifscData}
            ifscDetailsLoading={ifscDetailsLoading}
            accountActiveInactiveState={accountActiveInactiveState}
            setAccountActiveInactiveState={setAccountActiveInactiveState}
            currentAssociate={currentAssociate}
            setCurrentAssociate={setCurrentAssociate}
            openAssociatePopup={openAssociatePopup}
            setOpenAssociatePopup={setOpenAssociatePopup}
            shouldDisableBankConfirm={shouldDisableBankConfirm}
            isIconGrey={isIconGrey}
            bankLookupData={bankLookupData}
            verifyBankAccountError={verifyBankAccountError}
            bankLookupLoading={bankLookupLoading}
            showJointAccountAlert={showJointAccountAlert}
            verifyBankAccountLoading={verifyBankAccountLoading}
            showManualVirtualToggle={canShowManualVirtualToggle}
          />
        );
      case 2:
        return (
          <BeneficiaryAccountStepContact
            payload={payload}
            selectedValue={selectedValue}
            accountNameValidation={accountNameValidation}
            handleDivBtn={handleDivBtn}
            handleChange={handleChange}
            handleRadioBtn={handleRadioBtn}
            contactNumberValidation={contactNumberValidation}
            emailValidation={emailValidation}
          />
        );
      case 3:
        return (
          <BeneficiaryAccountStepCategories
            createRecipient={createRecipient}
            showAdditionalSection={showAdditionalSection}
            initialRecipientCount={initialRecipientCount}
            setShowAdditionalSection={setShowAdditionalSection}
            showAdditionalRecipient={showAdditionalRecipient}
            setShowAdditionalRecipient={setShowAdditionalRecipient}
            handleConfirmRecipients={handleConfirmRecipients}
            tempRecipients={tempRecipients}
            setTempRecipients={setTempRecipients}
            recipientButtonDisabled={recipientButtonDisabled}
            setRecipientButtonDisabled={setRecipientButtonDisabled}
            additionalChip={additionalChip}
            setAdditionalChip={setAdditionalChip}
            labelpopup={labelpopup}
            handleClose={handleClose}
            labels={labels}
            setLabels={setLabels}
            setLabelpopup={setLabelpopup}
            selectedLabelsCreate={selectedLabelsCreate}
            setSelectedLabelsCreate={setSelectedLabelsCreate}
            labelPopupLoading={labelPopupLoading}
            setLabelPopupLoading={setLabelPopupLoading}
            selectedCatFields={selectedCatFields}
            toggleSelection={toggleSelection}
            payload={payload}
            openAdditionalRecipients={openAdditionalRecipients}
            categories={categories}
          />
        );
      case 4:
        return (
          <BeneficiaryAccountStepConfirm
            payload={payload}
            selectedFields={selectedFields}
            categories={categories}
            recipients={createRecipient}
            manualVirtualAccount={manualVirtualAccount}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      {exitFlow && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopup
            headerTitle={globalText?.LEAVE_PAGE_WARNING_HEADER}
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            subtext={globalText?.LEAVING_PAGE_WILL_EXIT_FROM_CURRENT_FLOW}
            btnOneText={globalText?.STAY}
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setExitFlow(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText={globalText?.LEAVE}
            btnTwoBtnType="button"
            btnTwoHandleFunction={() => navigate(-1)}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {showAlertCategories && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopupWithBulletPoints
            headerTitle="Unsafe to proceed"
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            bulletPoints={[
              "All categories will be linked to a single account.",
              "It is recommended to distribute categories across appropriate accounts.",
            ]}
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setShowAlertCategories(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Proceed"
            btnTwoBtnType="button"
            btnTwoHandleFunction={() => handleNext()}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <div className="w-width-full flex flex-col items-center h-full-height bg-primary-bg">
        <div className="w-width-full">
          <div className="h-navbar-height hidden Qsmd:block"></div>
          <div className="h-[calc(var(--navbar-breadcrumb-height)-var(--navbar-height))] my-margin-sm Qsmd:my-margin-base bg-primary-nav Qlg:bg-transparent"></div>
        </div>

        <div className="flex justify-center items-end !bottom-bottom-base Qmd:min-h-[calc(var(--stepper-height)+var(--icon-sm))] min-h-stepper-height Qsmd:bg-transparent rounded-t-border-radius-md Qsmd:relative Qlg:bg-transparent bg-primary-nav rounded-b-border-radius-sm w-screen fixed Qsmd:top-top-base left-left-base z-z-index-overlay">
          <PrimaryStepper
            activeStep={activeStep}
            handleForwardAction={handleNext}
            handleBackwardAction={handleBack}
            dataArray={dataArray}
          />
        </div>

        <div className="fixed top-top-base left-left-base mt-margin-base w-width-full rounded-bl-border-radius-md rounded-br-border-radius-md z-z-index-header bg-primary-nav shadow-box-shadow-bottom lg:hidden block">
          <TopNavComponent
            topNavHeader="Beneficiary Account"
            topNavSubText={steps[activeStep]}
            isFormattingNotRequired
          />
        </div>

        <>
          <div
            className="mx-auto overflow-hidden h-full flex flex-col items-center relative w-width-full"
            ref={scrollIt}
          >
            <div className="h-mobile-create-header w-width-full hidden flex-shrink-0"></div>
            <div
              className={`w-width-full overflow-auto Qsmd:pt-padding-md Qsmd:pb-padding-md pt-padding-base h-full flex justify-center ${
                activeStep === GlobalConfiguration.lengthCheckZero &&
                direction === "next"
                  ? ""
                  : removeClassName === true
                    ? ""
                    : animationClass
              }`}
              style={{ scrollbarWidth: "none" }}
            >
              {renderCreateAccount()}
            </div>
          </div>
        </>

        <div className="h-stepper-moble-height flex-shrink-0 w-width-full Qsmd:hidden block"></div>
      </div>
    </>
  );
};

export default BeneficiaryAccountCreate;
